// shadcn/ui className helper — clsx + tailwind-merge.
//
// Used by every component under packages/shared-ui/src/ui/. Same implementation
// as the v0.2 `cx` we used for tremor-raw, renamed to `cn` for consistency
// with the shadcn ecosystem and AI tooling defaults.
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
